import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'AIJobsListStatusExcecution',
  pure: false
})
export class AIJobsListFilterStatusExcecution implements PipeTransform {
  transform(items: any[], filter: string): any {
    if (!items || filter == 'All') {
      return items;
    }    
    if (filter == 'null') {
      return items.filter(item => item.jobExecutionResult == null || item.jobExecutionResult == undefined);
    }
    if (filter == '1') {
      return items.filter(item => item.jobExecutionResult == true);
    }
    if (filter == '0') {
      return items.filter(item => item.jobExecutionResult == false);
    }
  }
}
